import type { AdvisorAccount } from "@/utils/accounting";
import { formatCOP, formatNumber } from "@/utils/format";

const ConsignmentStats = ({ accounts }: { accounts: AdvisorAccount[] }) => {
  const consigned = accounts.reduce((a, x) => a + x.consignedValue, 0);
  const debt = accounts.reduce((a, x) => a + x.debt, 0);
  const bought = accounts.reduce((a, x) => a + x.compradoValue, 0);
  const withStock = accounts.filter((x) => x.consignedUnits + x.ownedUnits > 0).length;

  const cards = [
    { icon: "ri-hand-heart-line", label: "Valor en consignación", value: formatCOP(consigned), bubble: "bg-secondary-500/25 text-secondary-200" },
    { icon: "ri-hand-coin-line", label: "Por cobrar a asesores", value: formatCOP(debt), bubble: "bg-accent-500/20 text-accent-200" },
    { icon: "ri-shopping-bag-3-line", label: "Vendido a asesores", value: formatCOP(bought), bubble: "bg-primary-500/25 text-primary-100" },
    { icon: "ri-team-line", label: "Asesores con mercancía", value: formatNumber(withStock), bubble: "bg-accent-500/15 text-accent-100" },
  ];

  return (
    <div className="grid grid-cols-2 xl:grid-cols-4 gap-3 md:gap-4">
      {cards.map((c) => (
        <div key={c.label} className="glass-panel rounded-lg p-4 animate-fade-up">
          <span className={`w-9 h-9 rounded-lg flex items-center justify-center ${c.bubble}`}>
            <i className={`${c.icon} text-lg`} />
          </span>
          <p className="text-[11px] text-foreground-500 mt-3">{c.label}</p>
          <p className="text-lg md:text-xl font-heading font-extrabold text-foreground-950 mt-0.5 break-words">
            {c.value}
          </p>
        </div>
      ))}
    </div>
  );
};

export default ConsignmentStats;